import { befehlSenden } from "../plattform/api";
import { idToken } from "../plattform/sitzung";
import { vorbereitungRegistrieren, type Eintrag } from "../plattform/warteschlange";

/**
 * Medien einer Nachricht (medien.md §4, §6). Eine Nachricht mit Datei liegt mit der Datei in der Warteschlange; vor dem
 * Senden fordert die App den Upload-Platz an und lädt die Datei direkt in den Eingang hoch. Ohne Netz bleibt der
 * Eintrag an seiner Stelle stehen, damit die Reihenfolge der eigenen Nachrichten erhalten bleibt (K16).
 */

const BEFEHL = "NachrichtSchreiben";

async function vorbereiten(e: Eintrag): Promise<{ daten: Record<string, unknown> } | { grund: string } | null> {
  const datei = e.datei;
  const anhang = (e.daten["Anhang"] ?? {}) as Record<string, unknown>;
  if (!datei) return { daten: e.daten };
  const platz = await befehlSenden("MedienUploadAnfordern", {
    meldungsId: `${e.meldungsId}-up`.slice(0, 64), geraetezeit: e.geraetezeit,
    daten: {
      Zweck: "Nachricht", Kanal: e.daten["Kanal"], Medienart: anhang["Medienart"], Inhaltstyp: datei.type || "application/octet-stream",
      Größe: datei.size, ...(datei instanceof File && datei.name ? { Dateiname: datei.name } : {}),
    },
  });
  if (platz.netzfehler || platz.status === 401 || platz.status >= 500) return null;
  if (!platz.ok) return { grund: platz.grund ?? "abgewiesen" };
  const url = platz.felder["uploadUrl"] as string;
  const kopf = (platz.felder["uploadHeader"] ?? {}) as Record<string, string>;
  try {
    const r = await fetch(url, { method: "PUT", headers: kopf, body: datei });
    if (!r.ok) return null;
  } catch {
    return null;
  }
  return { daten: { ...e.daten, Anhang: { Medienart: anhang["Medienart"], Upload: platz.kennungen["Upload"] } } };
}

vorbereitungRegistrieren(BEFEHL, vorbereiten);

/** Kurzlebige Leseadresse eines Anhangs (medien.md §6); `null` ohne Netz oder ohne Berechtigung. */
export async function abrufadresse(kanal: string, nachricht: string, teil: "medium" | "vorschau"): Promise<string | null> {
  const t = await idToken();
  try {
    const r = await fetch("/api/medien/abruf", {
      method: "POST", headers: { "Content-Type": "application/json; charset=utf-8", ...(t ? { Authorization: `Bearer ${t}` } : {}) },
      body: JSON.stringify({ Kanal: kanal, Nachricht: nachricht, Teil: teil }),
    });
    if (!r.ok) return null;
    const k = (await r.json()) as { url?: string };
    return k.url ?? null;
  } catch {
    return null;
  }
}
